import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "../../utils/api";

// Fires a lightweight, anonymous page-view ping on every route change —
// powers the admin "Most Visited Pages" report. Fire-and-forget: never
// awaited, never blocks rendering, and errors are swallowed so a tracking
// hiccup can never affect the actual page. Renders nothing.
const PageViewTracker = () => {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    if (lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;
    api.post("/analytics/pageview", { path: location.pathname }).catch(() => {});
  }, [location.pathname]);

  return null;
};

export default PageViewTracker;
